import { Box, IconButton, Menu } from '@mui/material';
import React, { FC } from 'react';
import MonitorIcon from '@mui/icons-material/Monitor';
import DetailsHolder from './DetailsHolder';

const IndexingSearchMachine: FC<{ farmId: number }> = ({ farmId }) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <React.Fragment>
      <Box sx={{ display: 'flex', alignItems: 'center', textAlign: 'center' }}>
        <IconButton
          onClick={handleClick}
          size="small"
          sx={{ ml: 2 }}
          aria-controls={open ? 'account-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
        >
          {' '}
          <MonitorIcon color="primary" />
        </IconButton>
      </Box>
      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        PaperProps={{
          elevation: 0,
          borderRadius: '20px',
          sx: {
            minWidth: '250px',
            maxWidth: '320px',
            padding: '10px',
            overflow: 'visible',
            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
            mt: 1.2,
            '&::before': {
              content: '""',
              display: 'block',
              position: 'absolute',
              top: 0,
              left: '50%',
              transform: 'translateX(-50%) translateY(-50%) rotate(45deg)',
              width: 8,
              height: 8,
              bgcolor: 'background.paper',
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: 'center', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'center', vertical: 'bottom' }}
      >
        <DetailsHolder farmId={farmId} />
      </Menu>
    </React.Fragment>
  );
};

export default IndexingSearchMachine;
